import { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ExpandLess, ExpandMore, MoreVert } from '@mui/icons-material';
import { Box, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { ParameterProps } from '../ParameterContainer';
import TrueFalse from '../../Common/TrueFalse';

import { updateAxesQueryParam } from '../../../redux/ChartPoperties/ChartPropertiesActions';
import {
  setParameterData,
  setParameterIntoFilters,
} from '../../../redux/Parameters/ParametersAction';
import { callQueryAPI } from '../../../redux/ChartPoperties/ChartControlsActions';
import { AxisType } from '../../CommonFunctions/aliases';
import { callQueryAPIDashboard } from '../../../redux/TabTile/TabTileActionsAndMultipleDispatches';

const Switch = ({
  parameter,
  handleEditParameter,
  propKey,
  editMode,
  showDash,
  color,
}: ParameterProps) => {
  const { chartProperties } = useSelector((state: any) => {
    return {
      chartProperties: state.chartProperties,
    };
  });
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [expanded, setExpanded] = useState(true);

  const defaultValue = parameter.userSelection
    ? parameter.userSelection === 'True'
      ? true
      : false
    : Boolean(parameter.columns?.defaultValue);

  const [active, setActive] = useState<boolean>(() => {
    if (parameter.mode === 'edit') {
      return (parameter.columns?.defaultValue as boolean) || false;
    }
    return defaultValue || false;
  });
  const currentChartAxesRef = useRef<any[]>([]);
  const currentChatFieldRef = useRef<any>(null);
  const currentChartAxesNameRef = useRef<any>(null);
  const itemIndexRef = useRef<any>(null);
  const isFirstRender = useRef(true);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleChange = () => {
    const value = !active ? 'True' : 'False';
    setActive((prev: boolean) => !prev);
    dispatch(setParameterData(parameter.parameterId, value));

    // if (currentChatFieldRef.current && currentChatFieldRef.current.isParameterized) {
    //   currentChatFieldRef.current.userSelection = [value];

    //   updateUserFilterItem(
    //     propKey,
    //     0,
    //     itemIndexRef.current,
    //     currentChatFieldRef.current,
    //     currentChartAxesNameRef.current,
    //   );
    // }
    Array.isArray(parameter.chartFilter) &&
      parameter.chartFilter.forEach((cf: any) => {
        if (!cf.currentChartAxesName?.includes('chartAxes_')) {
          if (cf.propKey) {
            const clonedField = {
              ...chartProperties.properties[cf.propKey].chartAxes[0].fields[cf.itemIndex],
            };
            clonedField.userSelection = [value];
            updateUserFilterItem(cf.propKey, 0, cf.itemIndex, clonedField, cf.currentChartAxesName);
          } else if (cf.itemIndex >= 0 && cf.currentChartAxesName) {
            chartProperties.propList[1].forEach((tabTileId: string) => {
              chartProperties.properties[tabTileId].chartAxes[0].fields.some((field: any) => {
                if (field.parameterId === parameter.parameterId) {
                  dispatch(
                    setParameterIntoFilters(
                      tabTileId,
                      parameter.parameterId,
                      field.uId,
                      cf.itemIndex,
                      cf.currentChartAxesName,
                    ),
                  );

                  const clonedField = {
                    ...chartProperties.properties[tabTileId].chartAxes[0].fields[cf.itemIndex],
                  };
                  clonedField.userSelection = [value];
                  updateUserFilterItem(
                    tabTileId,
                    0,
                    cf.itemIndex,
                    clonedField,
                    cf.currentChartAxesName,
                  );
                }
              });
            });
          }
        }
      }),
      callQueryAPIFilter();

    parameter?.chartFilter?.forEach((filter: any) => {
      if (filter?.currentChartAxesName?.includes('chartAxes_')) {
        const currentChartAxesName_ = filter?.currentChartAxesName.split('_')[1];
        if (filter.propKey) {
          const chartAxes = chartProperties.properties[filter.propKey]?.chartAxes;
          const chartFilter = chartAxes[chartAxes.length - 1].fields;
          chartFilter?.forEach((field: any, index: number) => {
            if (currentChartAxesName_ === field.enableOverrideForUID) {
              return;
            }
            if (field.uId === currentChartAxesName_) {
              const override_ = field.override;
              if (Array.isArray(override_) && override_.length > 0) {
                override_[0].fields.forEach((field_: any, index_: number) => {
                  if (field_.uId === filter.chartFilterId) {
                    if (field_.fieldtypeoption === 'Pick List') {
                      field_.userSelection = [value];
                    } else field_.exprInput = value;
                    field.override = override_;
                    updateUserFilterItem(
                      filter.propKey,
                      chartAxes.length - 1,
                      index,
                      field,
                      'chartAxes',
                    );
                    callQueryAPIFilter();
                  }
                });
              }
            }
          });
        } else {
        }
      }
    });
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const callQueryAPIFilter = () => {
    let callAPIDashboard = false;
    chartProperties.propList[1].forEach((tabTileId: string) => {
      chartProperties.properties[tabTileId].chartAxes[0].fields.some((field: any) => {
        if (field.parameterId === parameter.parameterId) {
          dispatch(callQueryAPI(tabTileId, true));
          callAPIDashboard = true;
        }
      });
      let measureAxes = chartProperties.properties[tabTileId].chartAxes.filter((axis: any) =>
        [AxisType.Measure, AxisType.X, AxisType.Y].includes(axis.name),
      );
      measureAxes.forEach((axes: any) => {
        axes.fields.some((field: any) => {
          if (field.override) {
            field.override[0].fields.some((FilterField: any) => {
              if (FilterField.parameterId === parameter.parameterId) {
                dispatch(callQueryAPI(tabTileId, true));
                callAPIDashboard = true;
              }
            });
          }
        });
      });
    });
    if (showDash && callAPIDashboard) {
      dispatch(callQueryAPIDashboard(true));
    }
  };

  const updateUserFilterItem = (
    propKey: string,
    bIndex: number,
    itemIndex: number,
    field: any,
    axesName: string,
  ) => {
    dispatch(updateAxesQueryParam(propKey, bIndex, itemIndex, field, axesName));
  };

  useEffect(() => {
    currentChartAxesRef.current = chartProperties.properties[propKey]?.chartAxes[0]?.fields || [];

    // Find the field where any chartFilter in parameter.chartFilter matches filter.uId
    currentChatFieldRef.current = currentChartAxesRef.current.find(
      (filter: any) =>
        Array.isArray(parameter.chartFilter) &&
        parameter.chartFilter.some((cf: any) => {
          if (cf.chartFilterId === filter.uId) {
            currentChartAxesNameRef.current = cf.currentChartAxesName;
            itemIndexRef.current = cf.itemIndex;
            return cf.chartFilterId === filter.uId;
          }
        }),
    );
  }, [chartProperties.properties[propKey]?.chartAxes[0]?.fields, parameter.chartFilter, propKey]);

  // if the parameter had any default value then it will update the Graph
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (currentChatFieldRef.current && currentChatFieldRef.current.isParameterized) {
      const value = active ? 'True' : 'False';
      currentChatFieldRef.current.userSelection = [value];
      // console.log(currentChatFieldRef.current);
      // console.log(value);
      updateUserFilterItem(
        propKey,
        0,
        itemIndexRef.current,
        currentChatFieldRef.current,
        currentChartAxesNameRef.current,
      );
      callQueryAPIFilter();
    }
    parameter?.chartFilter?.forEach((filter: any) => {
      if (filter?.currentChartAxesName?.includes('chartAxes_')) {
        const currentChartAxesName_ = filter?.currentChartAxesName.split('_')[1];
        const chartAxes = chartProperties.properties[propKey]?.chartAxes;
        const chartFilter = chartAxes[chartAxes.length - 1].fields;
        chartFilter?.forEach((field: any, index: number) => {
          if (currentChartAxesName_ === field.enableOverrideForUID) {
            return;
          }
          if (field.uId === currentChartAxesName_) {
            const override_ = field.override;
            if (Array.isArray(override_) && override_.length > 0) {
              override_[0].fields.forEach((field_: any, index_: number) => {
                if (field_.uId === filter.chartFilterId) {
                  if (field_.fieldtypeoption === 'Pick List') {
                    field_.userSelection = [active];
                  } else field_.exprInput = active;
                  field.override = override_;
                  updateUserFilterItem(propKey, chartAxes.length - 1, index, field, 'chartAxes');
                  callQueryAPIFilter();
                }
              });
            }
          }
        });
      }
    });
  }, [parameter.chartFilter]);

  return (
    <Box
      sx={{
        width: '100%',
        position: 'relative',
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>
          <Typography
            variant="body2"
            sx={{
              mb: 0.5,
              fontWeight: 500,
              transform: 'capitalize',
              color: color,
              textAlign: 'start',
            }}
          >
            {parameter?.name}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: -1,
            transition: 'all 0.3s ease-in-out',
          }}
        >
          <IconButton
            size="small"
            id="basic-button"
            aria-controls={!!anchorEl ? 'basic-menu' : undefined}
            sx={{ color: color }}
            onClick={handleClick}
          >
            <MoreVert />
          </IconButton>
          <IconButton
            size="small"
            sx={{
              mr: '0.4rem',
              color: color,
            }}
            onClick={() => setExpanded((prev) => !prev)}
          >
            {expanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </Box>
      </Box>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem dense onClick={() => handleEditParameter(parameter.parameterId)}>
          Remove
        </MenuItem>
      </Menu>

      {expanded && (
        <Box
          sx={{
            border: '1px solid grey',
            borderRadius: '5px',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            height: '1.5rem',
            width: '100%',
            gap: '0.5rem',
            paddingInline: '0.2rem',
            '&.axisFilterField': {
              width: 'inherit',
            },
          }}
        >
          <TrueFalse active={active} handleChange={handleChange} />
        </Box>
      )}
    </Box>
  );
};

export default Switch;
